import React, { createContext, useState, useMemo } from "react";

export const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState("USD");

  const symbols = {
    USD: "$",
    INR: "₹",
  };

  const rates = {
    USD: 1,
    INR: 83,
  };

  // Memoized helpers
  const convertPrice = (price) => {
    if (!price) return 0;
    if (!rates[currency]) return price;
    return (price * rates[currency]).toFixed(2);
  };

  const value = useMemo(
    () => ({
      currency,
      setCurrency,
      convertPrice,
      currencySign: symbols[currency],
    }),
    [currency]
  );

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};
